var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"raporty"},[_c('rainbow-header',{scopedSlots:_vm._u([{key:"rainbowHeader",fn:function(){return undefined},proxy:true}])}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.widoczny),expression:"widoczny"}],staticClass:"lds-dual-ring"}),_c('TabelaObrotow',{on:{"test":_vm.laduje}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }